import jwtDecode from "jwt-decode";

/**
 * Extracts the organisation ID from the token stored in localStorage.
 * @returns {string|null} The organisation ID if available, otherwise null.
 */
export const getOrganisationIdFromToken = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.result?.token;

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.organisationId || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  }

  return null;
};